var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ pcStyle: _vm.isPc, mobileStyle: _vm.isMobile },attrs:{"id":"my-loading-box"}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-loading-content"},[_c('div',{attrs:{"id":"my-loading-content-box"}},[_c('img',{staticClass:"loading-img",attrs:{"width":"30","height":"30","src":require("@/assets/images/loading.png"),"alt":""}}),_c('div',{attrs:{"id":"my-loading-title"}})])])
}]

export { render, staticRenderFns }